<script>
export default {
  name: "articleList",
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    gotoInfo(item) {
      const {aid} = item
      if (!aid) return
      window.open(`https://dis.qidao123.com/portal.php?mod=view&aid=${aid}`)
    }
  }
}
</script>

<template>
  <div class="article-list">
    <div class="article-item" v-for="(item, index) in list">
      <div class="left">
        <el-image v-if="item.pic" :src="'https://dis.qidao123.com/data/attachment/' + item.pic" alt=""
                  style="height: 100%;width: 100%" fit="cover"></el-image>
        <el-image v-else src="https://dis.qidao123.com/template/comlimi_lmv7/images/nophoto.gif" alt=""
                  style="height: 100%;width: 100%" fit="cover"></el-image>
      </div>
      <div class="right" @click="gotoInfo(item)">
        <h2 class="title">{{ item.title }}</h2>
        <p class="profile">{{ item.summary }}</p>
        <div class="item-footer">
          <div class="myAvatar" @click.stop>
            <el-image class="avatar-img" fit="cover"
                      :src="'https://dis.qidao123.com/uc_server/avatar.php?uid=' + item.uid + '&size=small'"
                      alt=""></el-image>
            <a class="myUserName" :href="'https://dis.qidao123.com/space-uid-' + item.uid + '.html'">{{
                item.username
              }}</a>
            <el-divider direction="vertical"></el-divider>
            <span class="time">{{ item.dateline }}</span>
          </div>
          <div class="like">
            <i class="fa fa-eye"> {{ item.viewnum }}</i>
            <i class="fa fa-comments-o"> {{ item.commentnum }}</i>
            <!--            <i class="fa fa-star-o"> {{ 0 }}</i>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.article-list {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .article-item {
    display: flex;
    background: #ffffff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    gap: 10px;
    padding: 10px 15px;
    align-items: center;
    transition: all .3s;
    cursor: pointer;

    &:hover {
      //transform: translateY(-5px);
    }

    .left {
      height: 125px;
      aspect-ratio: 16/9;
      background: #F5F5F5;
      border-radius: 6px;
      overflow: hidden;
      box-sizing: border-box;
      padding: 5px;
    }

    .right {
      flex: 1;
      display: flex;
      gap: 10px;

      flex-direction: column;

      .title {
        font-size: 22px;
        cursor: pointer;

        &:hover {
          color: #ff5e52;
        }
      }

      .profile {
        // 最多只展示两行
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        color: #8c8c8c;
      }

      .item-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;

        .myAvatar {
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
          flex: 1;

          .avatar-img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            margin-right: 10px;
          }

          .myUserName {
            color: #ff5e52;
          }

          .time {
            color: #8c8c8c;
          }
        }

        .like {

          flex: 1;
          display: flex;
          gap: 5px;
          justify-content: right;
          color: #8c8c8c;
        }
      }
    }
  }
}
</style>